import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { SignatureComponent } from './signature.component';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [SignatureComponent],
  imports: [
    CommonModule,
    FormsModule,
    AngularSignaturePadModule
  ]
})
export class SignatureModule { }
